import { IBaseEntity } from "@formant/core/model/IBaseEntity";

function updateList<T extends IBaseEntity>(list: T[], updatedItem: T): T[] {
    const existingItemIndex = list.findIndex(
        item => item.id === updatedItem.id,
    );

    if (existingItemIndex !== -1) {
        // If the item already exists, update it by creating a new list
        return list.map(item =>
            item.id === updatedItem.id ? updatedItem : item,
        );
    } else {
        // If the item doesn't exist, add it to the list by creating a new list
        return [...list, updatedItem];
    }
}

export { updateList };
